import { useRef, useEffect } from "react";
import cx from "classnames";
import "./Checkbox.scss";
import { Check, Minus } from "lucide-react";

type CheckboxProps = {
  as?: string; // Changed from "input" to allow for custom components
  id?: string;
  name?: string;
  checked?: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLLabelElement>) => void;
  label?: string;
  subLabel?: string;
  className?: string;
};

const Checkbox: React.FC<CheckboxProps> = ({
  as = "input",
  id,
  name,
  checked = false,
  indeterminate = false,
  disabled = false,
  onChange,
  onClick,
  label,
  subLabel,
  className,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const checkboxClasses = cx(
    "Checkbox",
    {
      "Checkbox--Checked": checked && !indeterminate,
      "Checkbox--Indeterminate": indeterminate,
      "Checkbox--Disabled": disabled,
    },
    className,
  );

  return (
    <label className={checkboxClasses} onClick={onClick}>
      {as === "input" && (
        <input
          ref={inputRef}
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          className="Checkbox__Input"
        />
      )}
      <span className="Checkbox__Control">
        {checked && !indeterminate && <Check className="Checkbox__CheckIcon" />}
        {indeterminate && <Minus className="Checkbox__IndeterminateIcon" />}
      </span>
      <div className="Checkbox__LabelContainer">
        <span className="Checkbox__Label">{label}</span>
        {subLabel && <span className="Checkbox__SubLabel">{subLabel}</span>}
      </div>
    </label>
  );
};

export { Checkbox };
